import React, { createContext, useContext, useState } from "react";

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loadingStates, setLoadingStates] = useState({
    app: false,
    api: false,
    chart: false,
  });

  const setLoading = (type, isLoading) => {
    setLoadingStates((prev) => ({
      ...prev,
      [type]: isLoading,
    }));
  };

  const isLoading = Object.values(loadingStates).some((state) => state);

  const value = {
    loadingStates,
    setLoading,
    isLoading,
  };

  return (
    <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
  );
};
